var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticStyle:{"border-radius":"5px","margin":"10px","padding":"0px"},attrs:{"color":"white","type":"","size":"sm"},on:{"click":_vm.masrafSil}},[_c('b-icon',{attrs:{"icon":"trash-fill","type":"border","size":"medium","variant":"danger"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }